import { queryOptions, useQuery } from "@tanstack/react-query";

import { getSystemNotificationsAPI } from "@client/systemNotifications/getSystemNotificationsAPI";

import { notificationKeys } from "./notificationKeys";

export const systemNotificationsQuery = queryOptions({
  queryKey: notificationKeys.systemList(),
  queryFn: getSystemNotificationsAPI,
});

export const useFetchSystemNotificationsQuery = () => {
  const { data, ...rest } = useQuery(systemNotificationsQuery);

  return {
    systemNotifications: data?.data,
    ...rest,
  };
};
